"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrinterStatusController = void 0;
const value_observer_1 = require("@dqm/value-observer");
const react_1 = __importStar(require("react"));
function getCurrentStatus(provider) {
    if (provider.getStatus() === value_observer_1.ValueStatus.Ok) {
        return provider.getValue();
    }
    return "";
}
const PrinterStatusController = ({ children, valueService, }) => {
    const printerStatusProvider = valueService.getProvider("printer-status");
    const currentStatus = getCurrentStatus(printerStatusProvider);
    const [status, setStatus] = (0, react_1.useState)(printerStatusProvider.getStatus());
    const [printerStatus, setPrinterStatus] = (0, react_1.useState)(currentStatus);
    (0, react_1.useEffect)(() => {
        const unregister = valueService.registerListener("printer-status", (provider) => {
            setStatus(provider.getStatus());
            setPrinterStatus(getCurrentStatus(provider));
        });
        return () => {
            unregister();
        };
    }, [valueService]);
    if (typeof children !== "function") {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children({ status, printerStatus }));
};
exports.PrinterStatusController = PrinterStatusController;
//# sourceMappingURL=PrinterStatusController.js.map